import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AnnouncementProps } from './Announcement';
import { resetStore } from '../../applicationSlice';
import { unauthorize } from '../../Security/authorizationSlice';
import { ErrorAnnouncement } from './types';

interface announcementState {
  announcements: AnnouncementProps[];
  errors: ErrorAnnouncement[];
}

const initialState: announcementState = {
  /** Site Announcements rendered through the AnnouncementCenter above the Company App Bar */
  announcements: [],
  /** Error collection rendered as an Announcement through the ErrorAnnouncement component below the Company App Bar */
  errors: []
};

const announcementSlice = createSlice({
  name: 'announcementState',
  initialState,
  reducers: {
    /**
     * Add an Announcement to the collection to be displayed
     */
    queueAnnouncement(state, action: PayloadAction<Omit<AnnouncementProps, 'uniqueId'>>) {
      const newAnnouncement = {
        ...action.payload,
        uniqueId: Math.floor(Math.random() * 10000)
      };

      return {
        ...state,
        announcements: [...state.announcements, { ...newAnnouncement }]
      };
    },

    /**
     * Remove a single Announcement from the collection
     */
    clearAnnouncement(state, action: PayloadAction<number>) {
      const copy = [...state.announcements.filter((announcement) => announcement.uniqueId !== action.payload)];

      return {
        ...state,
        announcements: copy
      };
    },

    /**
     * Add an Error to the collection to be displayed to the user
     */
    appendErrorAnnouncement(state, action: PayloadAction<ErrorAnnouncement>) {
      return {
        ...state,
        errors: [...state.errors, { ...action.payload }]
      };
    },

    /**
     * Clear current errors
     */
    clearErrorAnnouncements(state) {
      return {
        ...state,
        errors: initialState.errors
      };
    },

    /**
     * Remove all of the Announcements from the collection
     */
    clearAllAnnouncements() {
      return {
        ...initialState
      };
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      ({ type }) => type === resetStore.type || type === unauthorize.type,
      () => initialState
    );
  }
});

export const { queueAnnouncement, appendErrorAnnouncement, clearAnnouncement, clearErrorAnnouncements, clearAllAnnouncements } =
  announcementSlice.actions;

export default announcementSlice;
